import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AudioState, AudioCategory, AudioMode, AudioIntensity } from '@/lib/audio/types';

export const useAudioStore = create<AudioState>()(
    persist(
        (set) => ({
            masterVolume: 0.7,
            fxVolume: 0.8,
            voiceVolume: 0.9,
            uiVolume: 0.35,

            mode: 'coach',
            intensity: 'standard',
            hapticsEnabled: true,

            setVolume: (category: AudioCategory, val: number) => set((state) => {
                const key = `${category}Volume` as keyof AudioState;
                return { ...state, [key]: Math.min(Math.max(val, 0), 1) };
            }),

            setMode: (mode: AudioMode) => set({ mode }),
            setIntensity: (intensity: AudioIntensity) => set({ intensity }),
            toggleHaptics: () => set((state) => ({ hapticsEnabled: !state.hapticsEnabled })),
        }),
        {
            name: 'palaestra-audio-settings',
        }
    )
);
